import React from "react";
import { Controller } from "react-hook-form";
import { Select, Form } from "antd";
import './index.css'

const { Option } = Select;

const SelectInput = ({name,
   control,
   label,
   placeholder,
   options,
   errors,
   required,
   mode,  
   allowClear,        
   onChange,
   disabled,
   defaultValue }) => (
   <Form.Item
      layout="vertical"
      label={
         <span>
            {label}
            {required && (
               <span className="ms-1" style={{ color: "red" }}>
                  *
               </span>
            )}
         </span>
      }
      validateStatus={errors[name] ? "error" : ""}
      help={errors[name]?.message}
   >
      <Controller
         name={name}
         control={control}
         render={({ field }) => (
            <Select
               {...field}
               mode={mode} // Pass mode here (e.g., "multiple")
               allowClear={allowClear} // Allow clearing selections
               placeholder={placeholder}
               disabled={disabled}
               defaultValue={defaultValue}
               
               showSearch
               optionFilterProp="children"
               // filterOption={(input, option) =>
               //    (option?.children || "")?.toLowerCase()?.includes(input?.toLowerCase())
               // }
               
               onChange={(value) => {
                  field.onChange(value); // Update react-hook-form's state
                  if (onChange) onChange(value); // Call the external onChange handler
               }}
             
            >
               {options?.map(option => (
                  <Option key={option?.value} value={option?.value}
                  style={{
                     color: disabled ? "black" : "inherit", // Gray color for disabled text
                     backgroundColor: disabled ? "#f5f5f5" : "inherit", // Optional: light gray background for disabled
                  }}
                  >
                     {option?.label}
                  </Option>
               ))}
            </Select>
         )}
      />
   </Form.Item>
);

export default SelectInput;